import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

interface Step {
  id: number;
  name: string;
  tabId: string;
  isComplete: boolean;
  description: string; // For tooltips
  documents: {
    docType: string;
    documentPath: string;
    documentName: string;
    latitude?: number;
    longitude?: number;
    geoJson?: string;
    propertyGeoJson?: string;
  }[];
  comments: { id: number; text: string; timestamp?: string }[];
}
@Component({
  selector: 'app-apoexecution',
  templateUrl: './apoexecution.component.html',
  styleUrls: ['./apoexecution.component.css']
})
export class ApoexecutionComponent implements OnInit {
steps: Step[] = [
    { id: 1, name: 'KML File', tabId: 'kml', isComplete: false, description: 'Upload KML file for site mapping', documents: [], comments: [] },
    { id: 2, name: 'Before/After Images', tabId: 'images', isComplete: false, description: 'Upload before and after images', documents: [], comments: [] },
    { id: 3, name: 'Plan/Estimate', tabId: 'plan', isComplete: false, description: 'Upload project plan or cost estimate', documents: [], comments: [] },
    { id: 4, name: 'DPR', tabId: 'dpr', isComplete: false, description: 'Upload Detailed Project Report', documents: [], comments: [] },
    { id: 5, name: 'Tender Document', tabId: 'tender', isComplete: false, description: 'Upload tender documents', documents: [], comments: [] },
    { id: 6, name: 'Work Order', tabId: 'workorder', isComplete: false, description: 'Upload work order details', documents: [], comments: [] },
    { id: 7, name: 'Completion Certificate', tabId: 'completion', isComplete: false, description: 'Upload completion certificate', documents: [], comments: [] }
  ];
selectedStep: Step | null = null;
 baseUrl = 'https://iwlms.s3.ap-south-1.amazonaws.com/';
  selectedFile: File | null = null;
  commentText: string = '';
  isUploading = false;
  isSubmittingComment = false;
  fileError: string | null = null;
  commentError: string | null = null;

  constructor(private http: HttpClient,private router: Router) {}

  ngOnInit(): void {
    if (this.steps.length > 0) {
      this.selectedStep = this.steps[0];
    }
  }

  selectStep(step: Step): void {
    this.selectedStep = step;
    this.selectedFile = null;
    this.commentText = '';
    this.fileError = null;
    this.commentError = null;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      // Basic file validation
      if (file.size > 10 * 1024 * 1024) { // 10MB limit
        this.fileError = 'File size exceeds 10MB limit.';
        this.selectedFile = null;
      } else if (this.selectedStep?.tabId === 'kml' && !file.name.endsWith('.kml')) {
        this.fileError = 'Please upload a KML file for this step.';
        this.selectedFile = null;
      } else {
        this.selectedFile = file;
        this.fileError = null;
      }
    }
  }

  uploadDocument(): void {
    if (!this.selectedStep || !this.selectedFile) return;

    this.isUploading = true;
    this.fileError = null;

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('stepId', this.selectedStep.id.toString());
    let docType = 'Supportive Document';
    if (this.selectedFile.type.includes('image')) {
      docType = this.selectedStep.tabId === 'images' ? 'Before Image' : 'After Image';
    } else if (this.selectedFile.name.endsWith('.kml')) {
      docType = 'KML File';
    }
    formData.append('docType', docType);

    this.uploadToS3(formData).subscribe({
      next: (response: any) => {
        this.selectedStep!.documents.push({
          docType,
          documentPath: response.path,
          documentName: this.selectedFile!.name
        });
        this.selectedStep!.isComplete = true;
        this.selectedFile = null;
        this.isUploading = false;
      },
      error: (error) => {
        this.fileError = 'Failed to upload document. Please try again.';
       // console.error('Upload error:', error);
        this.isUploading = false;
      }
    });
  }

  addComment(): void {
    if (!this.selectedStep || !this.commentText.trim()) return;

    if (this.commentText.length > 500) {
      this.commentError = 'Comment cannot exceed 500 characters.';
      return;
    }

    this.isSubmittingComment = true;
    this.commentError = null;

    this.saveComment({
      stepId: this.selectedStep.id,
      text: this.commentText
    }).subscribe({
      next: (response: any) => {
        this.selectedStep!.comments.push({
          id: response.id,
          text: this.commentText,
          timestamp: new Date().toISOString() // Mock timestamp
        });
        this.selectedStep!.isComplete = true;
        this.commentText = '';
        this.isSubmittingComment = false;
      },
      error: (error) => {
        this.commentError = 'Failed to save comment. Please try again.';
        //console.error('Comment save error:', error);
        this.isSubmittingComment = false;
      }
    });
  }

  private uploadToS3(formData: FormData): Observable<any> {
    // Replace with actual API endpoint
    return of({
      path: `apo_sites/map_${formData.get('stepId')}/${this.selectedFile!.name}`
    });
  }

  private saveComment(comment: { stepId: number; text: string }): Observable<any> {
    // Replace with actual API endpoint
    return of({
      id: Math.floor(Math.random() * 1000)
    });
  }

  isImage(doc: any): boolean {
    return doc.docType === 'Before Image' || doc.docType === 'After Image';
  }

  getProgress(): number {
    return (this.steps.filter(step => step.isComplete).length / this.steps.length) * 100;
  }
  goBack(): void {
    // Option 1: Navigate to parent route
    this.router.navigate(['/apo-list']); // Adjust route as needed
    // Option 2: Emit event for parent component to handle
    
  }
}
